export const MERCHANDISE_LEDGER_PATH = "/reports/merchandiseLedger";

const CATALOG_ITEM_PARAM = "catalogItem";
const PRODUCT_PARAM = "product";

// catalogItem (scoped, single-variant) takes precedence: a URL never carries both, so ?product= is ignored.
export interface MerchandiseLedgerParams {
    productId?: string;
    catalogItemId?: string;
}

export const merchandiseLedgerPath = ({ productId, catalogItemId }: MerchandiseLedgerParams) => {
    if (catalogItemId) {
        return `${MERCHANDISE_LEDGER_PATH}?${CATALOG_ITEM_PARAM}=${catalogItemId}`;
    }

    if (productId) {
        return `${MERCHANDISE_LEDGER_PATH}?${PRODUCT_PARAM}=${productId}`;
    }

    return MERCHANDISE_LEDGER_PATH;
};

export const parseMerchandiseLedgerParams = (search: string): MerchandiseLedgerParams => {
    const params = new URLSearchParams(search);
    const catalogItemId = params.get(CATALOG_ITEM_PARAM) ?? undefined;
    const productId = catalogItemId ? undefined : params.get(PRODUCT_PARAM) ?? undefined;

    return { catalogItemId, productId };
};
